module.exports = __webpack_public_path__ + "img/43.ae63804b.png";